module.exports = __webpack_public_path__ + "static/media/branch-detail-375.ea4da6f7.jpg";